import { Callout } from "./Callout";

const inputs = [
  {
    name: "image",
    type: "file",
    allowedFileTypes: ["svg", "png", "jpeg", "jpg"],
  },
  {
    name: "imageWidth",
    type: "number",
    defaultValue: 150,
  },
  {
    name: "heading",
    type: "string",
    defaultValue: "Heading Text",
  },
  {
    name: "copy",
    type: "longText",
    defaultValue: "<p>Some richtext copy</p>",
  },
];

const CalloutBlock = {
  component: Callout,
  name: "Callout",
  section: "Content Components",
  inputs,
  noWrap: true,
  canHaveChildren: false,
};

export default CalloutBlock;
